<div class="photo">
  @if ((imageType$ | async); as imageType;) {
    @if (localPreviewSrc$ | async; as localPreviewSrc) {
      <img draggable="false" class="w-full absolute h-full inset-0 object-cover" [src]="localPreviewSrc">
    }
    @if ((imageType === 'photo' && (photo$ | async)); as photo) {
      @if (photo.width && photo.height && !staticThumbnail) {
        <app-photo
          [photo]="photo"
          sizes="(max-width: 1280px) 80vw, 400px"
        class="h-full"></app-photo>
      } @else {
        <app-photo [photo]="photo" sizes="400px" class="h-full"></app-photo>
      }
      @if (!readonly) {
        @if (primary$|async) {
          <span class="photo__primary-label">Primaire foto</span>
        }
        <div class="photo__menu">
          <vwui-menu>
            <vwui-menu-option data-test="menu-option-primary" (click)="setPrimaryPhoto()">Als primaire foto instellen</vwui-menu-option>
            <vwui-menu-option data-test="menu-option-focus" (click)="setFocusPoint()">Focuspoint instellen</vwui-menu-option>
            <vwui-menu-option data-test="menu-option-delete" (click)="deletePhoto()">Verwijderen</vwui-menu-option>
          </vwui-menu>
        </div>
      }
    }
  }

  @if (loading$ | async) {
    <div class="photo__loading">
      <vwui-spinner></vwui-spinner>
    </div>
  }
</div>
